// Campus photo for /colleges/university-of-new-mexico: CC BY 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AZimmerman_Library%2C_University_of_New_Mexico.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-new-mexico/; credited under the photo.
const photo = {
    "slug": "university-of-new-mexico",
    "alt": "Zimmerman Library on the University of New Mexico campus in Albuquerque, New Mexico",
    "src": "/colleges/university-of-new-mexico/campus-1600.webp",
    "srcSmall": "/colleges/university-of-new-mexico/campus-800.webp",
    "srcMid": "/colleges/university-of-new-mexico/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-new-mexico/og.jpg",
    "title": "Zimmerman Library, University of New Mexico",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AZimmerman_Library%2C_University_of_New_Mexico.jpg",
    "read": "2026-10-01"
};

export default photo;
